<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-25 14:28:44
 * @LastEditTime: 2021-03-04 15:38:17
-->
<template>
  <div class="deviceDetail">
    <el-form :inline="true">
      <el-row>
        <el-col :span="12">
          <el-form-item label="SN：">
            <span>{{deviceItem.deviceSn}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="`${$t('lang.Monitor.deviceName')}：`">
            <span>{{deviceItem.deviceName}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="`${$t('lang.Monitor.project')}：`">
            <span>{{deviceItem.firstLevelName}}</span>
            <span v-if="deviceItem.secondLevelName">&nbsp;/&nbsp;{{deviceItem.secondLevelName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="`${$t('lang.Monitor.deviceAddress')}：`">
            <span>{{deviceItem.deviceAddress}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    deviceItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      detailData: {

      }
    }
  }
}
</script>
<style>
.deviceDetail{
  padding-left: 20px;
  padding-top: 10px;
  /* min-width: 860px; */
}
</style>